import { useCallback, useContext } from 'react';
import { FilterList } from '@mui/icons-material';
import { FilterContext, useTranslate } from 'react-admin';
import { useIsEnabledSidebarFilter } from '@/components/ra-lists/FilterSidebar';
import { Button as MUIButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Button } from '@/components/ra-buttons';
import { useListViewContext } from '@/components/ra-lists';
import { isFunction } from 'lodash';

function FilterSidebarButton() {
  const { setSidebarOpen } = useListViewContext();
  const filters = useContext(FilterContext);
  const hasFilterSidebar = useIsEnabledSidebarFilter();
  const translate = useTranslate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!hasFilterSidebar) {
    throw new Error('The <FilterSidebarButton> component requires the <List aside={<FilterSidebar />}> prop to be set');
  }

  if (filters === undefined) {
    throw new Error('The <FilterSidebarButton> component requires the <List filters> prop to be set');
  }

  const handleFilterClick = useCallback(() => {
    if (isFunction(setSidebarOpen)) {
      setSidebarOpen(true);
    }
  }, [setSidebarOpen]);

  return isMobile ? (
    <MUIButton className="add-filter" onClick={handleFilterClick}>
      <FilterList sx={{ fontSize: '1rem', mr: 0.5 }} />
      <Typography variant="h6">{translate('ra.action.add_filter')}</Typography>
    </MUIButton>
  ) : (
    <Button label="ra.action.add_filter" onClick={handleFilterClick}>
      <FilterList />
    </Button>
  );
}

export { FilterSidebarButton };
